module.exports = __webpack_public_path__ + "img/icon-edit-underline.939b6fc6.svg";